var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKnowledge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 134,
    height: 134,
    viewBox: "0 0 134 134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_475",
    x: 0,
    y: 0,
    width: 134,
    height: 134,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#004869",
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#074673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#79a8cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41a1c8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3108",
    "data-name": "Group 3108",
    transform: "translate(-847 -5484.109)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 847, 5484.11)",
    filter: "url(#Ellipse_475)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_475-2",
    "data-name": "Ellipse 475",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(33 24)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "light-bulb-svgrepo-com",
    transform: "translate(903.803 5525.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2802",
    "data-name": "Path 2802",
    d: "M76,13.2a13.2,13.2,0,1,0-19.882,11.39v4.271a2.072,2.072,0,0,0,2.044,2.033h9.2a2,2,0,0,0,1.955-2.033V24.663A13.174,13.174,0,0,0,76,13.2ZM54.659,11a1.067,1.067,0,0,1-.99-1.463,9.862,9.862,0,0,1,5.495-5.494,1.066,1.066,0,0,1,.793,1.98,7.729,7.729,0,0,0-4.308,4.307A1.067,1.067,0,0,1,54.659,11Z",
    transform: "translate(-49.604)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2803",
    "data-name": "Path 2803",
    d: "M110.619,247.75h-11a1.11,1.11,0,0,0-1.144,1.066v.067a1.167,1.167,0,0,0,1.144,1.133h1.168a4.4,4.4,0,0,0,8.794,0h1.035a1.092,1.092,0,0,0,1.055-1.133v-.067A1.034,1.034,0,0,0,110.619,247.75Z",
    transform: "translate(-91.965 -214.728)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledge);
export default __webpack_public_path__ + "static/media/knowledge.fc682d56c03b901d0c0ba7a655ecf6eb.svg";
export { ForwardRef as ReactComponent };